import { Button, DynamicContent, IconRow } from 'components'

import {
  BsArrowRightSquare,
  BsExclamationOctagon,
  BsExclamationTriangle,
} from 'react-icons/bs'

import { useTranslation } from 'react-i18next'
import { Submission } from 'common.types'
import './MailInBallotErrorScreen.scss'
import { useDynamicFormContent, useOneStop } from 'hooks'

export const MailInBallotErrorScreen = () => {
  const FIND_VOTING_LOCATION_URL = '/find/early'
  const submissions = JSON.parse(localStorage.getItem('submissions') ?? '{}')
  const timestamps = Object.keys(submissions).map(Number)
  const mostRecentTimestamp = Math.max(...timestamps)
  const mostRecentValue: Submission =
    submissions[mostRecentTimestamp.toString()]
  const { serverResponse } = mostRecentValue?.apiResponse
  const { t } = useTranslation(undefined, {
    keyPrefix: `mailInBallotForm.errorScreen`,
  })
  const { isOneStop, goToPlanToVote } = useOneStop()
  const { formContent } = useDynamicFormContent()
  const overrideContent =
    formContent?.formOverrides?.['voter-registration']?.error?.bottom

  if (!serverResponse?.data?.data?.response) {
    return null
  }
  const errors = serverResponse?.data?.data?.response?.errors
  if (!errors) {
    return null
  }
  const buttonWrapperStyle = { marginTop: 30, marginBottom: 40 }

  return (
    <div className="mail-in-ballot-error">
      <IconRow
        icon={BsExclamationOctagon}
        iconColor="red"
        text={t('notAccepted')}
      ></IconRow>
      {errors
        ? errors.map((error: any) => (
            <p className="mail-in-ballot-error__error">
              {Object.values(error)}
            </p>
          ))
        : null}
      <IconRow
        icon={BsArrowRightSquare}
        iconColor="blue"
        text={t('youStillHaveOptions')}
      ></IconRow>

      {overrideContent ? (
        <DynamicContent data={overrideContent} />
      ) : (
        <>
          <p>{t('optionOne')}</p>
          <p>{t('optionTwo')}</p>
          <div style={buttonWrapperStyle}>
            <Button
              label={t('findEarlyVotingLocation')}
              onClick={() => {
                if (isOneStop) {
                  goToPlanToVote()
                } else {
                  window.location.href = FIND_VOTING_LOCATION_URL
                }
              }}
              fullWidth={false}
            />
          </div>
          <p dangerouslySetInnerHTML={{ __html: t('optionThree') }}></p>
        </>
      )}
    </div>
  )
}
